module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"viewAll":"View All Rewards"},"lng_id":{"viewAll":"Lihat Semua Rewards"},"lng_th":{"viewAll":"ดูของสมนาคุณทั้งหมด"},"lng_zh":{"viewAll":"瀏覽所有獎賞"},"lng_ko":{"viewAll":"모든 리워드 보기"}}')
  delete Component.options._Ctor
}
